import { Button, Col, Input, Modal, QRCode, Row, Typography } from "antd";
import "./updateRoleModal.scss";
import React, { useEffect, useState } from "react";
import { HandleErrors } from "../../utils/handleErrors";
import {
  getPermissionsService,
  newRoleService,
  updateRoleService,
} from "../../services/role.service";
import { GetPermissionRes, GetRoleRes } from "../../interfaces/role.interface";
import { toast } from "react-toastify";

interface Props {
  show: boolean;
  onClose: () => void;
  role: GetRoleRes
}

export const UpdateRoleModal: React.FC<Props> = (props) => {
  const [show, setShow] = useState(false);

  const [loading, setLoading] = useState(false);

  const [permissions, setPermissions] = useState<GetPermissionRes[]>([]);
  const [selectedPermissions, setSelectedPermissions] = useState<
    GetPermissionRes[]
  >([]);

  const [id, setId] = useState(0);
  const [name, setName] = useState("");
  const [description, setDescription] = useState("");

  useEffect(() => {
    getAllPermissions();
  }, []);

  useEffect(()=>{
    setName(props.role.name)
    setDescription(props.role.description)
    setSelectedPermissions(props.role.permissions)
    setId(props.role.id)
  },[props.role])

  const getAllPermissions = async () => {
    try {
      const res = await getPermissionsService({});
      setPermissions(res.list);
    } catch (error) {
      HandleErrors(error);
    }
  };

  const submit = async () => {
    try {

      if(!name){
        toast.error('نام را وارد کنید')
        return
      }

      if(selectedPermissions.length == 0){
        toast.error('حداقل یک دسترسی باید انتخاب کنید')
        return
      }
      setLoading(true);
      const res = await updateRoleService({
        id: id,
        description: description,
        name: name,
        permissions: selectedPermissions.map((i) => i.id),
      });
      setLoading(false);
      toast.success("نقش با موفقیت بروزرسانی شد");

      setShow(false);
      props.onClose();
      setSelectedPermissions([]);
      setName("")
      setDescription("")
      setId(0)
    } catch (error) {
      HandleErrors(error);
      setLoading(false);
    }
  };

  useEffect(() => {
    setShow(props.show);
  }, [props.show]);

  return (
    <div className="UpdateRoleModal">
      <Modal
        destroyOnClose={true}
        title={"ویرایش نقش"}
        onCancel={() => {
          setShow(false);
          props.onClose();
          setSelectedPermissions([]);
          setName("")
          setDescription("")
        }}
        open={show}
        footer={null}
        width={550}
      >
        <div className="UpdateRoleModalContent">
          <Row justify={"center"}>
            <Col xs={24} className="input-box">
              <Typography.Text className="title"><span style={{color: 'red'}}>*</span>نام: </Typography.Text>
              <Input
                className="input"
                value={name}
                onChange={(e) => {
                  setName(e.target.value);
                }}
              />
            </Col>
          </Row>
          <Row justify={"center"}>
            <Col xs={24} className="input-box">
              <Typography.Text className="title">توضیحات: </Typography.Text>
              <Input.TextArea
                className="input"
                value={description}
                onChange={(e) => {
                  setDescription(e.target.value);
                }}
              />
            </Col>
          </Row>
          <Row>
            <Col className="permissions-title-box">
              <Typography.Text className="title"><span style={{color: 'red'}}>*</span>دسترسی‌ها:</Typography.Text>
            </Col>
          </Row>
          <Row className="permission-wrapper">
            {permissions.map((item, index) => {
              const seletcted = selectedPermissions.find(
                (e) => e.id === item.id
              );
              return (
                <Col
                  xs={24}
                  className={
                    seletcted ? "permission-box-selected" : "permission-box"
                  }
                  onClick={() => {
                    let temp = [...selectedPermissions];
                    if (seletcted) {
                      temp = selectedPermissions.filter(
                        (e) => e.id != item.id
                      );
                    } else {
                      temp.push(item);
                    }
                    setSelectedPermissions(temp);
                  }}
                >
                  <div className="cb"></div>
                  <Typography.Text className="title">
                    {item.name}
                  </Typography.Text>
                </Col>
              );
            })}
          </Row>
          <Row>
            <Col xs={24} className="btn-box">
              <Button
                loading={loading}
                onClick={submit}
                block
                type="primary"
                className="btn"
              >
                تایید
              </Button>
            </Col>
          </Row>
        </div>
      </Modal>
    </div>
  );
};
